import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ColorPicker, Popover } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import ReactHtml from 'components/shared/ReactHtml';
import Fade from 'components/shared/animated/Fade';

import { validateColor, COLOR_ERRORS } from '../utils';

const VALIDATION_ERRORS = {
  [COLOR_ERRORS.LOW_CONTRAST]: t(
    'settings.tab.customization.color_validation.accessibility_error_low_constrast_html',
  ),
  [COLOR_ERRORS.INVALID_COLOR]: t(
    'settings.tab.customization.color_validation.invalid_color_error_html',
  ),
};

const ColorInput = ({
  id = 'company_settings_color_input',
  value,
  title,
  name,
  disabled,
  placeholder,
  showConstrastError = false,
  ariaDescribedBy = '',
  onChange = () => {},
}) => {
  const [colorPickerVisible, setColorPickerVisible] = useState(false);
  const ariaErrorId = `${id}_error`;
  const inputAriaDescribedBy = [ariaErrorId, ariaDescribedBy].join(' ');

  const error = validateColor(value, showConstrastError);

  return (
    <div>
      <div className="d-f ai-c mh-40">
        <input
          id={id}
          aria-describedby={inputAriaDescribedBy}
          className="NewInput NewInput--white f-1 fb-auto mr-8 w-fill"
          style={{ width: 'auto' }}
          type="text"
          disabled={disabled}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={onChange}
        />
        <Popover
          isHighPriority
          rootClassName="d-f"
          visible={colorPickerVisible}
          onClose={() => setColorPickerVisible(false)}
          activator={
            <button
              type="button"
              onClick={() => setColorPickerVisible(!colorPickerVisible)}
              className="u-resetBtn"
              aria-label={
                name === 'primaryColor'
                  ? t('settings.tab.customization.primary_color.title')
                  : t('settings.tab.customization.secondary_color.title')
              }
            >
              <div
                className="is-32 bdrs-4 border border-midnight-20"
                style={{ backgroundColor: value }}
              />
            </button>
          }
        >
          <ColorPicker
            color={value}
            onChange={color => onChange({ target: { name, value: color } })}
          />
        </Popover>
        <Fade in={!!error}>
          <Text
            id={ariaErrorId}
            aria-live="polite"
            className="d-f ml-8"
            variant={TEXT_VARIANTS.INSTRUX_ERROR}
          >
            <ReactHtml>{VALIDATION_ERRORS[error]}</ReactHtml>
          </Text>
        </Fade>
      </div>
    </div>
  );
};

ColorInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  ariaDescribedBy: PropTypes.string,
};

export default ColorInput;
